import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {Constants} from '../config/constants.config';
import {PageViewModel} from '../viewModels/page.viewModel';

@Injectable()
export class PageService {
    MEASURING_UNITS_TYPE = 'measuring_units';

    constructor(private readonly httpClient: HttpClient, private readonly constants: Constants) {
    }

    getPageByType(type: string): Observable<PageViewModel> {
        return this.httpClient.get<PageViewModel>(`${this.constants.apiURL()}/page/${type}/`);
    }

}
